module.exports = __webpack_public_path__ + "static/media/phone.c79e1da8.svg";